/* Meta Pixel + Conversions API helper — shared client-side wrapper.
 * Browser-side fbq() runs immediately; server-side CAPI call goes through our backend
 * `/api/analytics/meta/event` which forwards to Meta Graph API with hashed PII.
 * Both calls share the same event_id for automatic deduplication in Meta Events Manager. */

import { api } from "./api";

export const META_PIXEL_ID = "1408705654446792";

function readCookie(name) {
    if (typeof document === "undefined") return undefined;
    const m = document.cookie.split("; ").find((r) => r.startsWith(`${name}=`));
    return m ? decodeURIComponent(m.split("=")[1]) : undefined;
}

function newEventId() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/** Fires an event via the browser Pixel. `event_id` links it with the CAPI event for dedup. */
function pixelTrack(eventName, customData = {}, eventId) {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    try {
        window.fbq("track", eventName, customData, { eventID: eventId });
    } catch (e) {
        // swallow — analytics must never break the app
    }
}

/** Sends the same event through the backend Conversions API (server → Meta). */
async function capiTrack(eventName, eventId, params = {}) {
    try {
        await api.post("/analytics/meta/event", {
            event_name: eventName,
            event_id: eventId,
            event_source_url: typeof window !== "undefined" ? window.location.href : undefined,
            custom_data: params.custom_data || {},
            user_data: {
                ...(params.user_data || {}),
                fbp: readCookie("_fbp"),
                fbc: readCookie("_fbc"),
            },
        });
    } catch { /* silent — never let analytics break the app */ }
}

/** Fires an event through BOTH the browser Pixel and the server-side CAPI with a shared event_id. */
export function trackMeta(eventName, custom_data = {}, user_data = {}) {
    const eventId = newEventId();
    pixelTrack(eventName, custom_data, eventId);
    // fire-and-forget server call
    void capiTrack(eventName, eventId, { custom_data, user_data });
    return eventId;
}

/** PageView helper — call from a route-change effect. */
export function trackPageView() {
    return trackMeta("PageView");
}
